import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '@heycatch/sdk';

// Delays HeyCatch's analytics.init() (and the cookie it sets) until the
// visitor is off /login and /register, so those auth requests never carry
// the HeyCatch cookie. Runs once, the first time the route isn't login/register.
const SKIP_PATHS = ['/login', '/register'];

export const HeyCatchInitGate = () => {
  const location = useLocation();
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current || SKIP_PATHS.includes(location.pathname)) return;
    analytics.init({
      projectKey: 'hck_pk_VhVcSVS0dgquyVGMdTqsmQ8_lqD11mIc',
      install: {
        framework: 'react',
        frameworkVersion: '19',
        agent: 'other',
      },
    });
    initialized.current = true;
  }, [location.pathname]);

  return null;
};

export default HeyCatchInitGate;
